import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ContactImage from '../components/ContactImage';
import { startCall, transferCall } from '../reducers/calls';
import { contactsSearched } from '../reducers/contacts';
import styles from '../styles/contact.scss';
import { PhoneIcon, TransferIcon } from './icons';
const baseActions = [
    {
        icon: React.createElement(PhoneIcon, null),
        onClick: (props) => {
            var _a;
            props.callClick();
            (_a = props.collapse) === null || _a === void 0 ? void 0 : _a.call(props);
        },
        isVisible: (props) => !props.isTransferring,
    },
    {
        icon: React.createElement(TransferIcon, null),
        onClick: (props) => {
            var _a;
            props.transferClick(props.transferCallId);
            (_a = props.collapse) === null || _a === void 0 ? void 0 : _a.call(props);
        },
        isVisible: (props) => props.isTransferring,
        // }, {
        //   icon: <InfoIcon />,
        //   onClick: () => {
        //   },
        //   isVisible: props => props.type === 'phonebookentry'
    },
];
// Add a 'key' prop
const actions = baseActions.map((a, i) => (Object.assign(Object.assign({}, a), { key: i })));
const Contact = (props) => {
    const { number, name, description = '', email = '', id = '', type, status = '', useCallButton = false, focussed = false, expanded = false, expand = () => { }, collapse = () => { }, } = props;
    const dispatch = useDispatch();
    const transferringCall = useSelector((state) => state.calls.find((c) => c.transferInitiated === true));
    const isTransferring = !!transferringCall;
    const transferCallId = transferringCall === null || transferringCall === void 0 ? void 0 : transferringCall.id;
    const hasGrantedAudio = useSelector((state) => state.client.hasGrantedAudio);
    const callClick = () => {
        dispatch(startCall({ number, type, name, description, email }));
        dispatch(contactsSearched({ searchString: '' }));
    };
    const transferClick = (transferCallId) => {
        dispatch(transferCall({ id: transferCallId, number }));
        dispatch(contactsSearched({ searchString: '' }));
    };
    const extraProps = Object.assign(Object.assign({}, props), { isTransferring,
        transferCallId,
        hasGrantedAudio,
        callClick,
        transferClick });
    const containerClass = useCallButton
        ? styles.container
        : styles.container_clickable;
    const focussedClass = focussed ? styles.focussed : '';
    const expandedClass = expanded ? styles.container_expanded : '';
    const disabled = hasGrantedAudio ? '' : styles.disabled;
    const liClass = `${containerClass} ${focussedClass} ${expandedClass} ${disabled}`;
    // If visible is defined and false, strip out
    const visibleActions = actions.filter((a) => !(a.isVisible && !a.isVisible(extraProps)));
    const visibleActionsCount = visibleActions.length;
    const actionsMenu = (React.createElement("ul", { className: styles.actions_row }, visibleActions.map((a) => (React.createElement("li", { key: a.key, className: styles.action, onClick: () => a.onClick(extraProps) }, a.icon)))));
    return (React.createElement("li", { className: liClass, onClick: () => {
            if (!useCallButton) {
                if (isTransferring) {
                    transferClick(transferCallId);
                }
                else {
                    callClick();
                }
            }
        } },
        React.createElement("div", { className: styles.contact_row, onClick: () => {
                if (expanded) {
                    collapse();
                }
                else if (visibleActionsCount === 1) {
                    // If there's only one useable action in there, just do it
                    visibleActions[0].onClick(extraProps);
                }
                else {
                    expand();
                }
            } },
            React.createElement(ContactImage, { email: email, id: id, type: type, status: status }),
            React.createElement("div", { className: styles.info },
                React.createElement("span", { className: styles.name }, name),
                React.createElement("span", { className: styles.description }, description))),
        expanded && actionsMenu));
};
export default Contact;
